// Types for neural knowledge base
export interface NeuralKBEnrichment {
  cves: any[];
  writeups: any[];
  suggestions: string[];
  geminiSummaries: { date: string; summary: string }[];
  advancedFindings?: { tool: string; findings: string[]; date: string }[];
}

// API client to call the backend neural-kb API
export async function updateKnowledgeBaseAPI(payload: any) {
  const res = await fetch('/api/neural-kb', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return await res.json();
}

export async function queryKnowledgeBaseAPI(query: string) {
  const res = await fetch(`/api/neural-kb?query=${encodeURIComponent(query)}`);
  return await res.json();
} 